

<template>
  <div class="lesson">

    <br />
    <br />
    <div class="container mx-auto">   
      
      <div class="text-left">
        ピアノ・ソルフェージュ等のレッスンをします。
        <br />どのような楽器でも鍵盤・読譜・音感・リズム・和声・理論を軸にした内容になり、作曲の角度からのアプローチもあります。
        <br />普通にピアノのレッスンだと簡単な童謡に伴奏を付けられなかったりする、音楽の練習≒音ゲー・筋トレみたいな文化が音大レベルでもあったりします。
        <br />その他、お役に立てるケースとして自分のパート以外理解できない弦・管楽器の方や、ピアノロールを譜面だと思っているDTMerの方など。
        <br />大人から子供まで。
        <br />
        <br />
        <br />料金
        <br />
        <md-list>
          <md-list-item>初級 2000円/30min</md-list-item>
          <md-list-item>中級以上 2500円/30min</md-list-item>
          <md-list-item>体験レッスン1000円</md-list-item>
        </md-list>
        <br />回数に応じて割引致します。
        <br />
        <br />
        <br />

        <h6>アクセス</h6>市川市の下総中山駅周辺で、個人宅（狭い）です（徒歩６分）。
        <br />近辺のスタジオも使えます。出張レッスン（5km以内、５００円/回 程度）、Skypeレッスンも可。
        <br />
        <br />
        <h6>その他</h6>振込みや電子マネー、amazonポイントなどの支払い方法で和声やテーマの添削、DTM曲のアドバイスもいたします。（目安として芸大和声の初級で16小節で1000円）
        <br />出張演奏(4000円/1h)
        <br />
        <br />
        <br />
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfOGm8TIVOPRpji5gAQNm6dfrBHLVY84hYV_mUVfmkDNnXb9g/viewform"
        >体験レッスン申込み</a>
        <br />
        <br />
        <br />連絡は
        <br />iijimasat@gmail.com
        <br />各種SNS等でお願いします。
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "lesson",
  data() {
    jsonld=null;
    let jsonld2 = {
      "@id": "https://satoshi-19d88.firebaseapp.com/",
      name: "satoshi iijima",
      "@type": "music piano schoool",
      address: {
        "@type": "PostalAddress",
        address: "Tiba pref ichikawa city "
      },
      url: "https://satoshi-19d88.firebaseapp.com/"
    };
    //script=null
    //return {script};
  },
  created(){
    let jsonld = {
      "@id": "https://satoshi-19d88.firebaseapp.com/",
      name: "satoshi iijima",
      "@type": "music piano schoool",
      address: {
        "@type": "PostalAddress",
        address: "Tiba pref ichikawa city "
      },
      url: "https://satoshi-19d88.firebaseapp.com/"
    }
    let script = document.createElement("script");
    
    script.type = "application/ld+json"

    //script.appendChild("console.log('AAA')")

  },
  headd() {
    return {
      __dangerouslyDisableSanitizers: ["script"],
      script: [
        {
          innerHTML: `{
            "@context": "http://schema.org",
            "@type": "Article",
            "author": {
              "@type": "Person",
              "name": "Ruka Saito"
            },
            "publisher": {
              "@type": "Organization",
              "name": "_R",
              "logo": {
                "@type": "ImageObject",
                "url": "${process.env.BASE_URL + "/icon.png"}"
              }
            },
            "name": "${this.currentPost.fields.title}",
            "headline": "${this.currentPost.fields.title}",
            "image": "${
              _.isEmpty(this.currentPost.fields.heroImage)
                ? process.env.BASE_URL + "/img/noImg.png"
                : this.currentPost.fields.heroImage.fields.file.url
            }",
          }`,
          type: "application/ld+json"
        }
      ]
    };
  }
};
</script>

<!--
<script src="https://cdn.jsdelivr.net/npm/marked/marked.min.js"></script>
-->

<style scoped>
.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}
</style>
